import styled from "styled-components";

export const StyledBottomActionBar = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 25px;
  width: 100%;
  max-width: 500px;
  background: var(--rms-v2-surface);
  border-top-left-radius: ${(props) => (props.rounded ? "10px" : "0px")};
  border-top-right-radius: ${(props) => (props.rounded ? "10px" : "0px")};
  padding: 14px 20px;
  display: grid;
  grid-template-columns: ${(props) =>
    props.showCount ? "minmax(90px, 1fr) minmax(0, 2fr)" : "1fr"};
  gap: 16px;
  align-items: center;
  z-index: 35;

  .bottom-action-extra {
    grid-column: 1 / -1;
  }

  .bottom-action-count span {
    display: block;
    color: var(--rms-v2-text-muted);
    font-size: 11px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 1.1px;
  }

  .bottom-action-count strong {
    display: block;
    margin-top: 4px;
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 900;
  }

  .bottom-action-button-wrap {
    position: relative;
    min-width: 0;
  }

  .bottom-action-button-wrap > button.MuiButton-root {
    margin: 0;
    box-sizing: border-box;
    height: 40px;
    min-height: 40px;
    padding: 0 14px;
    max-width: 100%;
    position: relative;
    overflow: hidden;
    color: var(--rms-v2-surface) !important;
    -webkit-text-fill-color: var(--rms-v2-surface);
    font-weight: 700;
    text-transform: capitalize;
    box-shadow: none !important;
  }

  ${(props) =>
    !props.showCount &&
    `
      .bottom-action-button-wrap {
        width: 100%;
      }
    `}

  .bottom-action-button-wrap > button.Mui-disabled::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.68);
    pointer-events: none;
  }

  .bottom-action-button-wrap > button.Mui-disabled {
    background: var(--rms-v2-text-muted) !important;
    color: var(--rms-v2-surface-muted) !important;
    -webkit-text-fill-color: var(--rms-v2-surface-muted);
    opacity: 0.9;
  }

  .bottom-action-disabled-hitbox {
    background: transparent;
    border: 0;
    cursor: pointer;
    inset: 0;
    padding: 0;
    position: absolute;
    z-index: 2;
  }
`;
